import { NumberField } from './NumberField';

interface Props {
  prevSalary: number;
  prevEmployees: number;
  onChangeSalary: (n: number) => void;
  onChangeEmployees: (n: number) => void;
}

export function PrevYearInputs({ prevSalary, prevEmployees, onChangeSalary, onChangeEmployees }: Props) {
  return (
    <div className="section">
      <h2>
        <span className="num">2</span>前年度実績値の入力
      </h2>
      {/*
        TODO(2026-05-03): 役員報酬の取扱いを事務局に確認のうえ修正
        公募要領§補足1：「1人当たり給与支給総額（非常勤を含む全従業員）」
        過去のIT補助金FAQでは役員報酬を含む運用が一般的だが、
        現サイトの「役員報酬は含まない」という記述と齟齬の可能性あり。
        事務局QA確認後、本定義文を更新すること。参照：修正指示書 §4.4
      */}
      <p className="section-desc">
        直近事業年度（決算済み）の数値を入力します。<b>役員報酬・福利厚生費・退職金は除く</b>。
      </p>
      <div className="form-row">
        <div className="label">
          給与支給総額（前年度）<small>勘定科目内訳明細書 ⑭ より</small>
        </div>
        <div>
          <NumberField value={prevSalary} step={10000} min={0} onChange={onChangeSalary} />
          <span className="unit">円</span>
        </div>
      </div>
      <div className="form-row">
        <div className="label">
          従業員数（前年度）<small>正社員・パート・アルバイト（合計、整数）</small>
        </div>
        <div>
          <NumberField value={prevEmployees} integer min={0} onChange={onChangeEmployees} />
          <span className="unit">人</span>
        </div>
      </div>
    </div>
  );
}
